import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgProgress } from '@ngx-progressbar/core';
import { forkJoin } from 'rxjs';
import { User } from 'src/app/models/user';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AppState } from 'src/app/services/app.service';
import { McGriffClaimModel, McGriffLossRatio } from './analytics.model';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'self-ins-analytics',
    templateUrl: './analytics-page.component.html',
    styleUrls: ['./analytics-page.component.scss']
})
export class AnalyticsPageComponent implements OnInit, AfterViewInit {
    @ViewChild('claimsTable') public claimsSort: MatSort | undefined;
    public user: User = this.appState.user.getValue();
    public displayedClaimsColumns = ['claimNumber', 'dateOfLoss', 'reportDate', 'claimStatus', 'netIncurred', 'coverage', 'amazonId', 'lossDescription'];
    public displayedLossRatioColumns = ['scac', 'afpName', 'incidents',  'netIncurred'];
    public claims = new MatTableDataSource<McGriffClaimModel>([]);
    public lossRatio: McGriffLossRatio[] = [];
    public claimsGridFilterValue = '';
    public qnum: number = 0;
    public qsuffix: string = '';
    public valueDate: Date | null = null;

    constructor(private appState: AppState,
        private activeRouter: ActivatedRoute,
        private progressBar: NgProgress,
        private analyticsService: AnalyticsService) {}

    ngOnInit(): void {
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];
        });
        this.progressBar.ref().start();
        forkJoin([
            this.analyticsService.getMcGriffClaims(),
            this.analyticsService.getMcGriffLossRatio()
        ]).subscribe((data) => {
                const [claims, lossRatio] = data;
                this.claims.data = claims;
                this.lossRatio = lossRatio;

                const validClaims = claims.filter(c => c.uploadDate);
                this.valueDate = validClaims.length > 0 
                    ? validClaims.reduce((max, claim) => 
                        new Date(claim.uploadDate) > new Date(max.uploadDate) ? claim : max
                    ).uploadDate
                    : null;
                
                this.progressBar.ref().complete();
            });
    }

    public ngAfterViewInit() {
        this.claims.sort = this.claimsSort || null;
    }

    public applyClaimsFilter() {
        this.claims.filter = this.claimsGridFilterValue.trim().toLowerCase();
    }
}
